export const zIndices = {
  back: '-1',
  forward: '1',
  tableHeader: '2',
  panel: '3',
  popover: '4',
  floatingPanel: '5',
  dropdown: '6',
  tooltip: '7',
};
